import React from "react";
import "./terms-conditions.css";

const PrivacyPolicy = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Privacy Policy</h1>
      </header>

      <section className="tc-content mb-3">
        <p>We, at RRYO Private Limited (“Loanontip” or “We”), highly value your privacy and are committed to protecting your personal information. It is important for us to ensure that you (“You” or “Customer” or “User”), as a user of the website www.loanontip.com (the “Website”)—referred to as the “Platform” — clearly understand how and why we collect, use, store, and share your information.</p>
        <p>This Privacy Policy explains the nature and purpose of information collected from you, the manner in which it is processed, and the safeguards adopted to ensure its confidentiality and security.</p>
<p>This Privacy Policy has been prepared in compliance with:</p>

<li>The Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011;</li>
<li>The Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021;</li>
<li>The Guidelines on Digital Lending issued by the Reserve Bank of India (RBI); and</li>
<li>All other applicable laws, regulations, and guidelines issued by competent authorities, including but not limited to the RBI, concerning the collection, processing, and protection of personal and sensitive data.</li>

<p>For the purpose of loan facilitation, Loanontip operates as a digital lending platform owned and managed by RRYO Private Limited, in partnership with ACG Leasing Limited, an RBI-registered Non-Banking Financial Company (NBFC).</p>

<p>This Privacy Policy is an integral part of, and must always be read in conjunction with, the Terms and Conditions of Use of the Platform.</p>

        <h2>GRIEVANCE REDRESSAL MECHANISM</h2>
        <ol>
          <li><b>Grievance Redressal Mechanism of ACG Leasing Limited:</b> The borrower can raise their concerns pertaining to ACG Leasing Limited, EMI schedule, Loan Type, Processing Fee and/or any other charges or any other concern related to the Loan to authorised representatives of ACG Leasing Limited as below.</li>

           <li><b>Grievance Redressal Officer:</b> Borrowers are requested to address all their grievances at the first instance to the Grievance Redressal Officer. The contact details of the Grievance Redressal Officer are:
           </li>
           <p>Name of the Grievance Redressal Officer: Mr Naveen Bhilwara</p>
           <p>Designation: Sanction Head</p>
           <p>Company: Loanontip (ACG Leasing Limited)</p>
           <p>Address: 1710, 17th Floor, Sector 16, WTT, Noida 201301</p>
           <p>Contact: 9205155151</p>
           <p>Email: naveen.bhilwara@advancesalary.in</p>

           <p>The Grievance Redressal Officer may be reached on the number provided above anytime between 10:00 to 21:00 from Monday to Friday and 10:00 to 19:00 on Saturdays except public holidays or through the e-mail address above. The Grievance Redressal Officer shall endeavour to resolve the grievance within a period of 14 (fourteen) days from the date of receipt of a grievance.</p>

            <li><b>Nodal Officer :</b> If the Borrower does not receive a response from the Grievance Redressal Officer within 14 (fourteen) of making a representation, or if the Borrower is not satisfied with the response received from the Grievance Redressal Officer, the Borrower may reach the Nodal Officer on the number below anytime between 10:00 to 21:00 from Monday to Friday and 10:00 to 19:00 on Saturdays except public holidays or write to the Nodal Officer at the e-mail address below. The contact details of the Nodal Officer are provided below:
           </li>
           <p>Name of the Nodal Officer: Mr. Puneet Dixit</p>
           <p>Designation: Chief Operating Officer</p>
           <p>Company: Loanontip (ACG Leasing Limited)</p>
           <p>Address: 1710, 17th Floor, Sector 16, WTT, Noida 201301</p>
           <p>Contact: 9990548565</p>
           <p>Email: puneet.dixit@advancesalary.in</p>

           <p>In case the Borrower does not receive a response from the Grievance Redressal Official or the Nodal Officer within 1 (one) month from the date of making a representation to the Lender, or if the Borrower is not satisfied with the response so received, a complaint may be made in accordance with the ‘Reserve Bank-Integrated Ombudsman Scheme, 2021 (Ombudsman Scheme)’ to the Ombudsman in whose jurisdiction the office of ACG Leasing Limited. A copy of the Ombudsman Scheme is available on the website of the Reserve Bank of India at <a href="https://www.rbi.org.in" target="_blank">www.rbi.org.in</a> and also with the Nodal Officer of the ACG Leasing Limited.</p>
          
        </ol>
        

        <h2>Grievance Redressal Mechanism of RRYO Private Limited (Loanontip)</h2>
        <p>At RRYO Private Limited (operating under the brand name Loanontip), we are committed to providing transparent and efficient customer service.
In accordance with the Reserve Bank of India’s Digital Lending Guidelines, we have established a structured Grievance Redressal Mechanism to ensure that customer concerns are addressed promptly and fairly.
</p> 

<p>Please note that information or data deletion requests cannot be implemented for ongoing lending services until the completion or closure of the loan facility.</p>


        <h2>1. Lodging a Grievance</h2>
        <p>Borrowers may raise concerns or grievances related to Loanontip or the services offered through the platform, including but not limited to issues concerning loan application, EMI schedule, loan type, processing fee, repayment, or any other operational aspect, by contacting our Grievance Redressal Officer using the details provided below.</p>

        
        <h2>2. Grievance Redressal Officer</h2>
        <p>Borrowers are requested to address all grievances at the first instance to the Grievance Redressal Officer (GRO).</p>

        <p><b>Name: <br />
        Designation: <br />
        Company: RRYO Private Limited (Loanontip) <br />
        Address: <br />
        Contact Number: <br />
        Email <br />
          </b></p>

          <p>The Grievance Redressal Officer may be reached on the contact details provided above between 10:00 AM to 9:00 PM (Monday to Friday) and 10:00 AM to 7:00 PM (Saturday), excluding public holidays.
All complaints will be acknowledged and resolved within fourteen (14) working days from the date of receipt.
</p>
      
        <h2>3. Nodal Officer</h2>
        <p>If the borrower does not receive a response from the Grievance Redressal Officer within 14 days, or if the borrower is not satisfied with the resolution provided, the matter may be escalated to the Nodal Officer at the details below.</p>

        
        <p><b>Name: <br />
        Designation: <br />
        Company: RRYO Private Limited (Loanontip) <br />
        Address: <br />
        Contact Number: <br />
        Email <br />
          </b></p>

          <p>The Nodal Officer shall review the matter and endeavor to provide a resolution at the earliest possible time.</p>

        <h2>Escalation to the RBI Ombudsman</h2>

        <p>If the grievance remains unresolved beyond 30 days from the date of the initial complaint, or if the borrower is not satisfied with the final response, the borrower may approach the Reserve Bank of India – Integrated Ombudsman under the Reserve Bank – Integrated Ombudsman Scheme, 2021, using the following contact details:</p>

        <p><b> Website:</b> https://cms.rbi.org.in <br />
Borrowers should mention their complaint reference number when escalating to the RBI Ombudsman for faster resolution.
</p>
        
      </section>
    </div>
  );
};

export default PrivacyPolicy;
